module.exports = __webpack_public_path__ + "static/img/group.6606b452.gif";